import { createSelector, createSlice } from '@reduxjs/toolkit';

export const getIsMaxTaskCountReached = createSelector(
  state => state.tasks.completedTaskCount,
  state => state.tasks.maxTaskCount,
  (completedTaskCount, maxTaskCount) => completedTaskCount >= maxTaskCount
);

export const getShowFeedbackDrawer = store =>
  store.tasks?.showFeedbackDrawer || false;

// once task reaches to max count show feedback drawer
const FEEDBACK_THRESHOLD = 5;

// TODO: move logic to reducer for reducing prop drilling
const initialState = {
  maxTaskCount: FEEDBACK_THRESHOLD,
  completedTaskCount: 0,
  showFeedbackDrawer: false,
};

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    incrementTaskCount: state => {
      state.completedTaskCount = state.completedTaskCount + 1;
    },
    resetTaskCount: state => {
      state.completedTaskCount = 0;
      state.showFeedbackDrawer = false;
    },
    changeFeedbackDrawer: (state, action) => {
      state.showFeedbackDrawer = action.payload;
    },
    closeFeedbackDrawer: state => {
      state.showFeedbackDrawer = false;
    },
  },
});

export const {
  incrementTaskCount,
  resetTaskCount,
  closeFeedbackDrawer,
  changeFeedbackDrawer,
} = tasksSlice.actions;

export default tasksSlice.reducer;
